import { createGlobalStyle, keyframes } from 'styled-components';
import { calc4k } from './utilities';
import { getParameterByName } from './utilities';

//margin-top: ${getParameterByName('desktop') ? 0 : calc4k(125)};

export const GlobalStyle = createGlobalStyle`
    *,
    *::before,
    *::after {
        margin: 0;
        padding: 0;
        box-sizing: inherit;
    }
    
    html {
        box-sizing: border-box;
        background-color: #000000;
        color: #fff;
        position: relative;
        
        overflow: hidden;
        transform: ${ p => p.transform ? p.transform : 'none' }; 
    }    
    
    body {
        overflow: hidden;
        font-family: BauPro, sans-serif;
    }
    
    h1,h2,h3,h4,h5,h6 {
        font-family: MaisonNeue, sans-serif;
    }
`;

export const colors = {
    black: '#000000',
    darkGrey: '#171717',
    grey: '#919191',
    lightGrey: '#D6D6D6',
    white: '#FFFFFF',
    gold: '#D8B271'
};

export const fadeOut = keyframes`
    from {
        opacity: 0
    }
    to {
        opacity: 1
    }
`;

export const fadeIn = keyframes`
    from {
        opacity: 1
    }
    to {
        opacity: 0
    }
`;

export const gradient = {
    purple: 'linear-gradient(270deg, #3F2448 0%, #2B1433 100%)',
    black: 'linear-gradient( to right, #000, rgba( 0,0,0,0.45 ) )',
    blackCircle:
        'radial-gradient(closest-corner, transparent 0%, rgba(0,0,0,.1) 20%, black 100%)'
};

export const padding = {
    side: calc4k(80),
    sideDouble: calc4k(160),
    sideTriple: calc4k(240),
};

export const fonts = {
    body: 'BauPro, sans-serif',
    headline: 'MaisonNeue, sans-serif'
};